import { selectSelectedTransaction } from '../../../../../store/workspace/selectors';
import { setTransactionDetailModal } from '../../../../../store/workspace/slice';
import { useDispatch, useSelector } from '../../../../../store/store';
import Button from '../../../../../components/Button';
import Modal from '../../../../../components/Modal';
import styles from './styles.module.scss';
import {
    CheckSolidIcon,
    TimesSolidIcon,
    BillingDetailIcon,
    NotApplicableIcon,
} from '../../../../../assets/icons';

export default function TransactionDetail() {
    const dispatch = useDispatch();
    const transaction = useSelector(selectSelectedTransaction);

    const statusText = () => {
        switch (transaction?.status) {
            case 'paid':
                return (<>
                    <CheckSolidIcon />
                    <span>Paid Successfully</span>
                </>);
            case 'unpaid':
                return (<>
                    <TimesSolidIcon />
                    <span>Paid Unsuccessful</span>
                </>);
            case 'refund':
                return (<>
                    <NotApplicableIcon />
                    <span>Paid Refunded</span>
                </>);
            default:
                return '';
        };
    };

    const downloadReceipt = () => {
        if (!transaction?.receipt_url) return;
        window.open(transaction.receipt_url, '_blank');
    };

    return (
        <Modal
            size='sm'
            title='Billing details'
            icon={<BillingDetailIcon />}
            childClassName={styles.wrapper}
            closeFunc={() => dispatch(setTransactionDetailModal(false))}
        >
            <div
                className={styles.status}
                data-status={transaction?.status}
            >
                {statusText()}
            </div>
            <div className={styles.row}>
                <span className={styles.row_prop}>Invoice number</span>
                <span className={styles.row_val}>{transaction?.invoice_id}</span>
            </div>
            <div className={styles.row}>
                <span className={styles.row_prop}>Status</span>
                <span className={styles.row_val}>{transaction?.status}</span>
            </div>
            <div className={styles.row}>
                <span className={styles.row_prop}>Amount</span>
                <span className={styles.row_val}>{transaction?.amount_paid ? `${transaction.amount_paid / 100}$` : '----'}</span>
            </div>
            <div className={styles.row}>
                <span className={styles.row_prop}>Date</span>
                <span className={styles.row_val}>{transaction ? new Date(transaction.created * 1000)?.toDateString() : '----'}</span>
            </div>
            <div className={styles.actions}>
                <Button
                    text='Close'
                    type='Outline-Dark'
                    className={styles.actions_btn}
                    onClick={() => dispatch(setTransactionDetailModal(false))}
                />
                <Button
                    type='Primary'
                    onClick={downloadReceipt}
                    className={styles.actions_btn}
                    text={`Download ${transaction?.status === 'unpaid' ? 'Invoice' : 'Receipt'}`}
                />
            </div>
        </Modal>
    );
};
